import { InjectionToken } from '@angular/core';
import { type StaticEnvironmentModel } from './models/static-environment.model';

export const STATIC_ENVIRONMENT = new InjectionToken<StaticEnvironmentModel>('static environment');
